import { movies } from '@/mocks/movies';
import MovieCard from '@/components/base/MovieCard';

export default function LatestMovies() {
  const latestMovies = movies.filter((m) => m.isNew).slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-3xl font-bold text-foreground-900 font-heading mb-2">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500">
              每日更新最新影视资源，追剧不停歇
            </p>
          </div>
          <a
            href="/category/dianying"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer transition-colors duration-200"
          >
            查看全部
            <span className="w-4 h-4 inline-flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {latestMovies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}